import {
  getCommentEditorState,
  readCommentContent,
} from '@main/shared/utils/lexical/comment-content';
import { useMemo } from 'react';

import { isWysiwygEmpty } from '../../wysiwyg/is-wysiwyg-empty';

export const useIsCommentEmpty = (text: string) => {
  return useMemo(() => {
    const { root } = getCommentEditorState(readCommentContent(text));
    // The reader does not validate every leaf field (a leaf's `children`, a tab's or line
    // break's `text`), so pass only each leaf's type and string text.
    const paragraphs = root.children.map((paragraph) => ({
      children: (paragraph.children ?? []).map(({ type, text: leafText }) => ({
        type,
        text: typeof leafText === 'string' ? leafText : undefined,
      })),
    }));

    return isWysiwygEmpty({ children: paragraphs });
  }, [text]);
};
